import { IKhoi } from "../../../model/respone/category/IKhoi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKhoiActionTypeDefine = {
    LOAD_START: {} as number | undefined,
    LOAD_SUCCESS: {} as IKhoi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IKhoi,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as IKhoi,
    SAVE_SUCCESS: {} as IKhoi,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
};

export const eKhoiActionTypeIds = generateActionTypeIds(eKhoiActionTypeDefine, "KHOI");

export type IKhoiActions = IGenericActionType<typeof eKhoiActionTypeDefine, "KHOI">;
